import { logError } from '@office-start/telemetry-service';
function updatePathAndQueryString(browserPathAndQueryString) {
    if (browserPathAndQueryString) {
        if (history && history.replaceState) {
            var state = history.state || {};
            history.replaceState(state, '', browserPathAndQueryString + window.location.hash);
        }
    }
}
export function handlePathQuery(browserPathAndQueryString) {
    try {
        updatePathAndQueryString(browserPathAndQueryString);
    }
    catch (err) {
        logError({
            eventName: 'ReactOhome_PathAndQuery_Set_Error',
            message: appendExceptionMessage('Caught exception while updating path and query string', err),
        });
    }
}
function appendExceptionMessage(errorPrefix, err) {
    if (err && err.message) {
        return errorPrefix + ': ' + err.message;
    }
    else {
        return errorPrefix;
    }
}
